export class AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "readCapacityUnits",
            "baseName": "readCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput.attributeTypeMap;
    }
    constructor() {
    }
}
